import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import CompanyUsers from './components/CompanyUsers';

const companyUsers = (props,{ t }) => (
  <Container>
    <CompanyUsers {...props} />
  </Container>
);

companyUsers.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(companyUsers);
